<template>
  <Modal
    :title="title"
    :body="`This ${kind} template is used in workflows. Please remove it from all workflows before deleting.`"
    action="Manage Workflows"
    action-color="indigo"
    @close-modal="emits('handle-cancel')"
    @handle-action="handleAction()"
  />
</template>

<script setup lang="ts">
import Modal from '@/components/shared/Modal.vue';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner';
import { useRouter } from 'vue-router';

const { push } = useRouter();
const { hideLocalLoadingSpinner } = useLoadingSpinnerStore();

type InUseByWorkflowModalProps = {
  name: string;
  kind: 'email' | 'sms';
};

const props = defineProps<InUseByWorkflowModalProps>();
const title = `Cannot Delete "${props.name}"`;

const handleAction = () => {
  hideLocalLoadingSpinner();
  push({ name: 'CandidateWorkflow' });
};

const emits = defineEmits(['handle-cancel']);
</script>
